
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Sport and Cultural </h1>
				</div>
			</div>
		</div>
	</div>
  <div class="breadcrumb-bottom-img">
    <img
        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
</div>
</section>
<section class="section section-sm summer-camp section-banner-bg-1">
  <div class="container">
    <div class="sec-title text-center">
      <h2>Registration For Harshita <span >Gautam</span></h2>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p>G H Raisoni Sport and Cultural Foundation, Nagpur, will organize a "Dance Workshop" by renowned choreographer
          Harshita Gautam on 4th February 2023 at Raisoni Campus, Mangalwari, Nagpur, at 1 PM. She has achieved success
          and popularity as a dancer, choreographer, and social media influencer in India.</p>
        <p>In this workshop, Bollywood & Free Style dances will be taught, and Ms. Harshita will share her dance secrets
          with the participants.</p>
        <p>To improve your Dance Performance, register today.</p>
        <p>Register at: <br>For Details Contact: <strong>9766063356</strong></p>
      </div>
      <div class="col-md-5">
        <div class="img-dance text-center">
          <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/harshita-gautam.jpg"
            class="img-fluid">
        </div>
      </div>
      <div class="col-md-7">
        <div class="p-2"></div>
        <!-- <iframe src="http://localhost:8012/angular-project/ghrscf-angular-new/classes/harshita-gautam.php" allowtransparency = "true" width="100%" height="550px" frameborder="0"></iframe> -->
        <form [formGroup]="registerForm" (ngSubmit)="submitForm()">
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">Name of Candidate:</label>
            <div class="col-sm-8">
              <input type="text" placeholder="Name of Candidate" formControlName="candidateName" name="candidateName"
                class="form-control">

            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">E-mail:</label>
            <div class="col-sm-8">
              <input type="email" formControlName="email" name="email" placeholder="Email" class="form-control">
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">Whatsapp Number:</label>
            <div class="col-sm-8">
              <input type="text" formControlName="phone" name="phone" minlength="10" maxlength="10"
                placeholder="Phone Number" class="form-control">
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">City:</label>
            <div class="col-sm-8">
              <input type="text" formControlName="city" name="city" placeholder="City" class="form-control">
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">School/College/Academy:</label>
            <div class="col-sm-8">
              <div class="form-check">
                <label class="form-check-label" for="radio1"></label>
                <input type="radio" formControlName="sttype" name="sttype" class="form-check-input"
                  value="School">School
              </div>
              <div class="form-check">
                <label class="form-check-label" for="radio2"></label>
                <input type="radio" formControlName="sttype" name="sttype" class="form-check-input"
                  value="College">College
              </div>
              <div class="form-check">
                <label class="form-check-label"></label>
                <input type="radio" formControlName="sttype" name="sttype" class="form-check-input"
                  value="Academy">Academy
              </div>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">Choose Academy:</label>
            <div class="col-sm-8">
              <div class="form-group row">
                <div class="form-check col-5">
                  <label class="form-check-label" for="radio1"></label>
                  <input type="radio" formControlName="chooseAcademy" id="radio1" name="chooseAcademy"
                    class="form-check-input" value="Raisoni" (click)="changediv('nc_signup')" [checked]="option1"
                    checked>Raisoni Student
                </div>
                <div class="form-check col-5">
                  <label class="form-check-label" for="radio2"></label>
                  <input type="radio" formControlName="chooseAcademy" id="radio2" name="chooseAcademy"
                    class="form-check-input" value="Other" (click)="changediv('cc_signup')">Other Student
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row mb-3">
            <label class="control-label col-sm-4">School/College/Academy Name:</label>
            <div class="col-sm-8">
              <input type="text" placeholder="Name of Institute" formControlName="instituteName" name="instituteName"
                class="form-control">
            </div>
          </div>
          <div class="form-group row mb-3" id="nc_signup" [hidden]="!option1">
            <label class="control-label col-sm-4">Raisoni Pay Amount:</label>
            <div class="col-sm-8">
              <b>Rs: 300</b>

            </div>
          </div>
          <div class="form-group row mb-3" id="cc_signup" [hidden]="!option2">
            <label class="control-label col-sm-4">Other Pay Amount:</label>
            <div class="col-sm-8">
              <input type="text" name="payamount" formControlName="payamount" class="form-control"
                placeholder="Enter Pay amount" [value]="">
            </div>
          </div>
          <div class="form-group row justify-content-center mb-3">
            <div class="col-sm-offset-2 col-sm-3">
              <input type="submit" name="submit" class="w-100 btn button--effect-2 mx-2 btn-color" value="Register">
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
